var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"},[_vm._v(" ©"+_vm._s(_vm.year)+" TeiaValues, Inc. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }